"use client";

import {useEffect, useState} from "react";

function ConsentManager() {
  const [isUpdateSet, setIsUpdateSet] = useState(false)
  const [isDefaultSet, setIsDefaultSet] = useState(false)

  useEffect(() => {

    const setDefaultConsent = () => {
      window.gtag('consent', 'default', {
        'ad_storage': 'denied',
        'ad_user_data': 'denied',
        'ad_personalization': 'denied',
        'analytics_storage': 'denied'
      });

      setIsDefaultSet(true)
      setIsUpdateSet(false)
    }

    if (!isUpdateSet && !isDefaultSet) {
      setDefaultConsent();
    }
    else {
      const userConsent = getUserConsent();
      if (!isUpdateSet && userConsent !== null) {
        // Parse the JSON string back to an object
        const consentData = JSON.parse(userConsent)

        // Debug each value
        // console.log('ad_storage:', consentData['ad_storage']);
        // console.log('ad_user_data:', consentData['ad_user_data']);
        // console.log('ad_personalization:', consentData['ad_personalization']);
        // console.log('analytics_storage:', consentData['analytics_storage']);

        window.gtag('consent', 'update', {
          'ad_storage': consentData['ad_storage'],
          'ad_user_data': consentData['ad_user_data'],
          'ad_personalization': consentData['ad_personalization'],
          'analytics_storage': consentData['analytics_storage']
        });

        setIsUpdateSet(true)
      }
    }
  }, [isDefaultSet]);

  return null;
}

export const GOOGLE_CONSENT_PARAM: string = "gcm"; //gcm stands for google consent mode

export const getUserConsent = () => {
  return localStorage.getItem(GOOGLE_CONSENT_PARAM);
};

export default ConsentManager;